import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { StyledDescription } from './style';
import { ProductOptions } from 'types/ProductData';
import { Tag } from 'ui';

interface DescriptionProps {
  text: string;
  showMore?: boolean; // If true, truncation + toggle button are enabled
  options?: ProductOptions[];
}

const CHARACTER_LIMIT = 450;

export const DescriptionWithShowMore: React.FC<DescriptionProps> = ({
  text,
  showMore = false,
  options,
}) => {
  const [showFull, setShowFull] = useState(false);
  const intl = useIntl();

  if (!text) return null;

  const isLongText = text.length > CHARACTER_LIMIT;
  const shouldTruncate = showMore && isLongText && !showFull;
  const displayedText = shouldTruncate
    ? text.slice(0, CHARACTER_LIMIT) + '...'
    : text;

  const toggleShow = () => setShowFull((prev) => !prev);

  return (
    <StyledDescription className="desc">
      <div className={'mobile-product-options-container'}>
        {options?.map((option: ProductOptions) => (
          <Tag key={option.id} className={'mobile-product-option-tag'}>
            {option.label}
          </Tag>
        ))}
      </div>
      {displayedText}
      {showMore && isLongText && (
        <span className="show-toggle" onClick={toggleShow}>
          {showFull
            ? intl.formatMessage({
                id: 'description.show_less',
                defaultMessage: 'Show less',
              })
            : intl.formatMessage({
                id: 'description.show_all',
                defaultMessage: 'Show all',
              })}
        </span>
      )}
    </StyledDescription>
  );
};
